import React from 'react';
import { contact, footer, nav, voterSignIn } from '../Data/Data';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container footer-inner">
                <a href="#home" className="footer-logo">
                    <img src={footer.footerLogo} alt={footer.alt} width="150" height="86" />
                </a>
                <nav className="footer-links" aria-label="Footer">
                    {nav.map((item) => <a key={item.href} href={item.href}>{item.label}</a>)}
                    <a href={voterSignIn}>Voter sign-in</a>
                </nav>
                <div className="footer-contact">
                    {contact.phones.map((p) => (
                        <a key={p.number} href={`tel:${p.number.replace(/\D/g, '')}`}>{p.label} {p.number}</a>
                    ))}
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                </div>
            </div>
            <div className="container footer-bottom">
                <p>© {currentYear} Instant Elect. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
